<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <BaseTable
        ref="baseTable"
        url="/admin/accident/periodicalLog"
        :tableData.sync="tableData"
        :columns="columns"
		    :searchParams="searchData">
      </BaseTable>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";

export default {
  name: "Log",
  comments: {},
  data() {
    return {
      searchData: {},
      tableData: [],
    };
  },
  watch: {
    $route: {
      async handler(val) {
        const { id } = val.query;
        if (id) {
          this.searchData.keyword = id;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    searchFormOption,
    columns
  },
  created() {},
  methods: {
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },
  },
};
</script>
